/* MoRetro Studio V27 - Connector telemetry only. */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const cfg = MTS.WorkshopConfig;
  const st = cfg.state;

  async function pollConnectorTelemetry(){
    try{
      const res = await fetch(`${cfg.API_BASE}/api/connector/telemetry`, {
        method:"GET",
        headers:{"Accept":"application/json"},
        cache:"no-store"
      });
      const data = await res.json().catch(()=>null);
      if(!res.ok || !data?.ok) throw new Error(data?.error || `Erreur Connector ${res.status}`);
      MTS.WorkshopMachines.applyConnectorTelemetry(data);
      return data;
    }catch(err){
      console.warn("Lecture Connector API impossible :", err.message || err);
      return null;
    }
  }

  function startPolling(){
    if(st.telemetryPollTimer) return;
    pollConnectorTelemetry();
    st.telemetryPollTimer = setInterval(pollConnectorTelemetry, 5000);
  }

  MTS.WorkshopConnector = {
    pollConnectorTelemetry,
    startPolling
  };
})(window.MTS);
